import React from 'react';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import HowItWorks from './components/HowItWorks';
import CTA from './components/CTA';

function App() {
  return (
    <div className="App bg-background min-h-screen">
      <Hero />
      <Benefits />
      <HowItWorks />
      <CTA />
      {/* Optional Footer could go here */}
    </div>
  );
}

export default App; 